/**
 * AI Agent 모드({@link AgentModePage})의 오른쪽 칸 iframe 이름.
 *
 * <p>그 칸에 뜬 앱은 {@link AppLayout} 이 이 이름을 보고 껍데기(상단바·사이드바)를 걷는다 —
 * 창 안에 창이 겹쳐 서지 않게. 개발 빌드에서만 읽는다.
 *
 * <p>페이지 모듈과 따로 둔 이유: AppLayout 이 페이지를 import 하면 그 화면 코드가 첫 번들에 실린다.
 */
export const AGENT_MODE_FRAME = 'bomi-agent-mode-frame';

export const inAgentModeFrame = (): boolean =>
  import.meta.env.DEV && typeof window !== 'undefined' && window.name === AGENT_MODE_FRAME;
